// ============================================================================
// APP CONFIG HOOK
// Reads global config from app_config table (kill-switch, etc.)
// Direct Supabase read — NOT Zustand state
// ============================================================================

import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

interface AppConfig {
  feedbackEnabled: boolean;
  loading: boolean;
}

export function useAppConfig(): AppConfig {
  const [feedbackEnabled, setFeedbackEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchConfig() {
      try {
        const { data, error } = await supabase
          .from('app_config')
          .select('value')
          .eq('key', 'feedback_system')
          .single();

        if (error) {
          console.warn('[AppConfig] Failed to fetch config:', error.message);
          return;
        }

        if (!cancelled && data?.value) {
          setFeedbackEnabled(data.value.enabled !== false);
        }
      } catch (err) {
        console.warn('[AppConfig] Unexpected error:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchConfig();
    return () => { cancelled = true; };
  }, []);

  return { feedbackEnabled, loading };
}
